import { render, staticRenderFns } from "./RecordsDialog.vue?vue&type=template&id=13a500bd&scoped=true"
import script from "./RecordsDialog.vue?vue&type=script&lang=js"
export * from "./RecordsDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13a500bd",
  null
  
)

export default component.exports